import { useContext } from "react";
import { StoreContext } from "../state/store";
import {
  loginBuyer,
  loginAgentAccount,
  loginBroker,
  loginSeller,
  logout as logoutService,
  registerBuyer,
  registerAgent,
  registerBroker,
  registerSeller,
} from "../auth/authService";
import { clearAdminStartGate } from "../../components/modals/AdminStarterModal";
import { recordAccountSession } from "../api/accountSettings";

export function useAuth() {
  const { state, dispatch } = useContext(StoreContext);

  async function login(credentials, role = "buyer") {
    let session;
    if (role === "agent") session = await loginAgentAccount(credentials);
    else if (role === "broker") session = await loginBroker(credentials);
    else if (role === "seller") session = await loginSeller(credentials);
    else session = await loginBuyer(credentials);
    dispatch({ type: "SET_SESSION", payload: session });
    if (session?.role === "admin") clearAdminStartGate();
    if (session?.userId && (session.role === "agent" || session.role === "broker" || session.role === "admin")) {
      recordAccountSession(session.userId);
    }
    return session;
  }

  async function register(data) {
    const role = data.role || "buyer";
    if (role === "agent") {
      const result = await registerAgent(data);
      dispatch({ type: "SET_SESSION", payload: result.session });
      return result;
    }
    if (role === "broker") {
      const result = await registerBroker(data);
      dispatch({ type: "SET_SESSION", payload: result.session });
      return result;
    }
    if (role === "seller") {
      const result = await registerSeller(data);
      dispatch({ type: "SET_SESSION", payload: result.session });
      return result;
    }
    const result = await registerBuyer(data);
    dispatch({ type: "SET_SESSION", payload: result.session });
    dispatch({ type: "SET_BUYER", payload: result.buyer });
    return result;
  }

  async function logout() {
    await logoutService();
    dispatch({ type: "CLEAR_SESSION" });
  }

  return {
    session: state.ui.session,
    user: state.ui.session,
    role: state.ui.session?.role || null,
    isAuthenticated: Boolean(state.ui.session),
    login,
    register,
    logout,
  };
}
